export default __webpack_public_path__ + "static/media/Left.d5602569.svg";